<ul class="horizontal-list ">
  @if (getmentItem(breadCrumbs)) {
    <li>
      <a href="javascript: void(0)" (click)="OnClickPath('Root')">Root</a>
    </li>
  }
  @for (crumb of breadCrumbs; track crumb) {
    @if (crumb?.type == 'folder') {
      <li>
        <a href="javascript: void(0)" (click)="OnClickPath(crumb)">{{crumb.name}}</a>
      </li>
    }
  }
</ul>